import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../.sourceflow/metadata.json";
import { useRouter } from 'next/router';

export default function SeoHead({
  site_name = "Lorien",
  page_name = "The global house of tech and transformation recruitment | Lorien",
  description = "Discover career opportunities and industry insights with Lorien, the Tech, Transformation and Telecom recruitment specialists.",
  canonical_link = "",
  og_image = "https://www.lorienglobal.com/site-assets/images/og-image-v3.jpg",
  og_img_alt = "The global house of tech and transformation recruitment | Lorien",
  en_gb = true,
  en_us,
  robots,
  removeUSHrefLang,
  removeUKHrefLang,
}) {
  const router = useRouter();

  const canonical_url = `https://www.lorienglobal.com${en_us ? "/us" : ""}${
    canonical_link ? "/" + canonical_link : ""
  }`;
  const alternate_url = `https://www.lorienglobal.com${en_gb ? "/us" : ""}${
    canonical_link ? "/" + canonical_link : ""
  }`;

  function getAttributes(id) {
    let obj = metaObject[`${router.asPath}/`]?.filter(item => item.id === id) ?? [];
    return obj[0]?.attributes;
  }
    
  return (
    <>
      <SourceFlowHead
          metaObject={metaObject}
          title={page_name}
          description={description}
          additionalMetaTags={[{
            property: 'og:site_name',
            content: site_name
          }, {
            property: 'title',
            content: page_name
          },
          ]}
          images={[
            {
              url: og_image,
              width: 1200,
              height: 600,
              alt: og_img_alt,
              type: "image/jpeg",
            },
          ]}
          robots={robots}
          canonical={canonical_url}
          locale={en_gb ? "en-gb" : en_us ? "en-us" : null}
          languageAlternates={
            !removeUSHrefLang && !removeUKHrefLang &&
            [
              {
                hrefLang: (en_gb ? "en-gb" : en_us ? "en-us" : null),
                href: canonical_url,
              },
              {
                hrefLang: (getAttributes("alternates")?.hreflang != '' ? getAttributes("alternates")?.hreflang : null) ?? (en_gb ? "en-us" : en_us ? "en-gb" : null),
                href: (getAttributes("alternates")?.url?.trim() != '' ? getAttributes("alternates")?.url?.trim() : null) ?? alternate_url,
              },
            ]
        }
      />
    </>
  );
}

SeoHead.defaultProps = {
  robots: null,
};
